import { Check } from "lucide-react";

const BENEFITS = [
  {
    title: "A clearer head, fast",
    body:
      "Stop spiraling between job boards. Get a single page that tells you what to focus on this week.",
  },
  {
    title: "Skills audit grounded in reality",
    body:
      "We map what you actually do — not just job titles — against what the market still values and pays for.",
  },
  {
    title: "AI‑resistant career paths",
    body:
      "Identify roles and niches where your human judgment, taste, and relationships are the product.",
  },
  {
    title: "A weekly rhythm, not a binge",
    body:
      "Small, doable actions every week. Designed for people with bills, families, and limited bandwidth.",
  },
  {
    title: "Honest, jargon‑free guidance",
    body:
      `No hustle culture. No "learn 10x to survive". Just calm advice from people who've changed careers themselves.`,
  },
  {
    title: "Private by default",
    body:
      "Your answers and plan stay yours. You decide if and when to share anything.",
  },
];

export default function Benefits() {
  return (
    <section
      id="benefits"
      className="bg-slate-50 py-24 lg:py-32"
      data-testid="benefits-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <p className="text-sm uppercase tracking-[0.18em] text-sky-700 font-medium">
            What you get
          </p>
          <h2
            className="mt-4 text-3xl lg:text-4xl tracking-tight leading-tight font-medium text-slate-900"
            data-testid="benefits-heading"
          >
            Support that respects your time, your money, and your nervous system.
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            {"This isn't a course you'll never finish. It's an ongoing, structured companion for the next chapter of your working life."}
          </p>
        </div>

        <ul className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-10">
          {BENEFITS.map((b, i) => (
            <li
              key={b.title}
              className="flex gap-4"
              data-testid={`benefit-item-${i + 1}`}
            >
              <span className="mt-1 inline-flex h-7 w-7 flex-none items-center justify-center rounded-full bg-emerald-50 text-emerald-700 border border-emerald-100">
                <Check className="h-4 w-4" />
              </span>
              <div>
                <h3 className="text-base lg:text-lg font-medium text-slate-900">
                  {b.title}
                </h3>
                <p className="mt-1.5 text-sm lg:text-base text-slate-600 leading-relaxed">
                  {b.body}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
